import React from "react";
import { BRAND_COLOR } from "../../common/constants";
import { Link } from "react-router-dom";

import registerBookImg from "../../assets/register-book.png";
import joinMeetingImg from "../../assets/join-meeting.png";
import oneToOneImg from "../../assets/one-to-one.png";
import practiceImg from "../../assets/practice.png";

const steps = [
 {
 title: "Register",
 subtitle: "Sign up for the first time",
 icon: "📱",
 image: registerBookImg,
 details: [
 "Sign up for the first time",
 "Get 5 free sessions automatically"
 ]
 },
 {
 title: "Book Your Session",
 subtitle: "Choose your preferred time",
 icon: "🗓️",
 image: joinMeetingImg,
 details: [
 "Go to speakboldwithkk.com",
 "Or open the Speak Bold Club App",
 "View the 'Upcoming Live Sessions' tab",
 "Book your first slot"
 ]
 },
 {
 title: "Join the Meeting",
 subtitle: "Access your session",
 icon: "⏳",
 image: oneToOneImg,
 details: [
 "Open your timetable page",
 "Click the 'Join' button",
 "Access meetings 5 minutes early",
 "Install the Zoom app beforehand"
 ]
 },
 {
 title: "Practice with a Partner",
 subtitle: "Improve your speaking skills",
 icon: "👥",
 image: practiceImg,
 details: [
 "Match with a practice partner",
 "Pairings depend on your session type"
 ]
 },
];

const HowItWorks = () => {
 const isMobile = window.innerWidth <= 768;

 return (
 <section
 id="how-it-works"
 style={{
 width: "100%",
 padding: isMobile ? "50px 16px" : "80px 20px",
 backgroundColor: "#f9faff",
 }}
 >
 {/* ===== HEADER ===== */}
 <div style={{ textAlign: "center", marginBottom: isMobile ? 40 : 60 }}>
 <h2
 style={{
 fontSize: isMobile ? 26 : 36,
 marginBottom: 10,
 color: BRAND_COLOR,
 }}
 >
 How Does It Work? 📱
 </h2>

 <p
 style={{
 fontSize: isMobile ? 15 : 17,
 color: "#555",
 maxWidth: 700,
 margin: "0 auto",
 lineHeight: 1.5,
 }}
 >
 Follow these simple steps to start your English speaking journey
 </p>
 </div>

 {/* ===== CARDS ===== */}
 <div
 style={{
 maxWidth: 1300,
 margin: "0 auto",
 display: "grid",
 gridTemplateColumns: isMobile
 ? "1fr"
 : "repeat(auto-fit, minmax(260px, 1fr))",
 gap: isMobile ? 18 : 24,
 }}
 >
 {steps.map((step, index) => (
 <div
 key={index}
 style={{
 backgroundColor: "#fff",
 borderRadius: 14,
 overflow: "hidden",
 boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
 transition: isMobile ? "none" : "transform 0.3s ease",
 }}
 onMouseEnter={(e) => {
 if (!isMobile)
 e.currentTarget.style.transform = "translateY(-6px)";
 }}
 onMouseLeave={(e) => {
 if (!isMobile)
 e.currentTarget.style.transform = "translateY(0)";
 }}
 >
 {/* ===== IMAGE ===== */}
 <div
 style={{
 height: isMobile ? 160 : 190,
 width: "100%",
 overflow: "hidden",
 }}
 >
 <img
 src={step.image}
 alt={step.title}
 loading="lazy"
 style={{
 width: "100%",
 height: "100%",
 objectFit: "cover",
 }}
 />
 </div>

 {/* ===== CONTENT ===== */}
 <div style={{ padding: isMobile ? 16 : 20 }}>
 <div
 style={{
 fontSize: isMobile ? 24 : 28,
 marginBottom: 8,
 }}
 >
 {step.icon}
 </div>

 <h3
 style={{
 fontSize: isMobile ? 18 : 20,
 marginBottom: 4,
 color: "#222",
 }}
 >
 Step {index + 1}: {step.title}
 </h3>

 <p
 style={{
 fontSize: isMobile ? 15 : 18,
 fontWeight: 600,
 color: BRAND_COLOR,
 marginBottom: 12,
 }}
 >
 {step.subtitle}
 </p>

 <ul
 style={{
 fontSize: isMobile ? 14 : 16,
 color: "#555",
 lineHeight: 1.6,
 paddingLeft: 20,
 margin: 0,
 }}
 >
 {step.details.map((detail, detailIndex) => (
 <li key={detailIndex} style={{ marginBottom: 6 }}>
 {detail}
 </li>
 ))}
 </ul>
 </div>
 </div>
 ))}
 </div>

 {/* ===== CALL TO ACTION ===== */}
 <div style={{ textAlign: "center", marginTop: isMobile ? 40 : 60 }}>
 <Link
 to="/register"
 style={{
 display: "inline-block",
 backgroundColor: BRAND_COLOR,
 color: "white",
 padding: isMobile ? "12px 24px" : "14px 32px",
 borderRadius: 8,
 textDecoration: "none",
 fontSize: isMobile ? 16 : 18,
 fontWeight: 600,
 transition: "background-color 0.3s ease",
 }}
 onMouseEnter={(e) => {
 e.target.style.backgroundColor = "#026b73";
 }}
 onMouseLeave={(e) => {
 e.target.style.backgroundColor = BRAND_COLOR;
 }}
 >
 Get Started - It's Free! 🚀
 </Link>
 </div>
 </section>
 );
};

export default HowItWorks;